import { render, staticRenderFns } from "./ReportHeader.vue?vue&type=template&id=77ffc8ef&scoped=true&"
import script from "./ReportHeader.vue?vue&type=script&lang=ts&"
export * from "./ReportHeader.vue?vue&type=script&lang=ts&"
import style0 from "./ReportHeader.vue?vue&type=style&index=0&id=77ffc8ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ffc8ef",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomSheet } from 'vuetify/lib/components/VBottomSheet';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBottomSheet,VBtn,VCard,VCardActions,VCardText,VIcon,VImg})
